import { Requester } from './Requester';
import { ISurveyFull, TableQueryParams } from '../types';

export const GetSurveys = async (
    options: TableQueryParams
): Promise<{ surveys: ISurveyFull[]; totalRecords: number } | null> => {
    try {
        const response = await Requester<{ surveys: ISurveyFull[]; totalRecords: number }>({
            path: `surveys/paged`,
            method: 'PUT',
            payload: options
        });

        if ('surveys' in response && Array.isArray(response.surveys)) return response;
        return null;
    } catch (e) {
        console.error('Get surveys request failed');
        return Promise.reject(e);
    }
};
